<template>
  <div class="policy">
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
.policy {
  .font-size(12, 18);
  .text-muted.less-muted();

  margin-top: @gutter-xs;

  a {
    .text-muted.less-muted();

    text-decoration: underline;
  }
}
</style>
